import React, { useEffect, useMemo, useState } from 'react';
import { View, StyleSheet, Dimensions, TouchableOpacity, Platform } from 'react-native';
import CustomHeader from '../../customHeader/CustomHeader';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import { BottomBarDLSType, ButtonSizeDLS, ButtonTypeDLS, ColorTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, TextAlignTokens, TypographyTypeDLS } from '@voltmoney/schema';
import Typography from '../../typography/Typography';
import TextInput from '../../textInput/TextInput';
import { RegexConfig, UPDATE_REQUEST_TYPE } from '../constants';
import BottomBar from '../../bottomBarDLS/bottomBarDLS';
import NeedHelpDC from '../NeedHelpDC';
import BottomSheet from '../BottomSheet';
import { isMobile } from '../../stack/utils';
import { getScreenType } from '../utils';
import { ModalAlignmentEnum } from '@voltmoney/types';
import Icon from '../../icon/Icon';
import ButtonDLSBase from '../../button/ButtonDLS.base';
import OtpModalScreenDc from '../OtpModalScreenDc';
const UpdateEmailScreen = ({ height, backAction, triggerAction, isDarkMode, caption, state = InputStateToken.DEFAULT, action, otpAction, contactUsDetails, proceedAction, otpModal, errorModal, closeModal, handleCloseOtpModalAction, defaultErrorModal, modalHeight, errorMessage, otpErrorModal, }) => {
    const [inputValue, setInputValue] = useState('');
    const [currentState, setCurrentState] = useState(InputStateToken.DEFAULT);
    const [validNumber, setValidNumber] = useState(false);
    const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [currentModalHeight, setCurrentModalheight] = useState(0);
    const [showOtpErrorModal, setShowOtpErrorModal] = useState(false);
    useEffect(() => {
        setShowErrorModal(errorModal);
        setShowOtpModal(otpModal);
    }, [otpModal, errorModal]);
    useEffect(() => {
        setCurrentModalheight(modalHeight);
    }, [modalHeight]);
    useEffect(() => {
        setShowOtpErrorModal(otpErrorModal);
    }, [otpErrorModal]);
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    const headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { title: '', goBackAction: backAction, hideNeedHelp: false, needHelpAction: handleNeedHelp, triggerAction: triggerAction, showNeedHelpNewArch: true }));
    }, []);
    const handleSubmit = async () => {
        setLoading(true);
        await triggerAction({
            ...proceedAction,
            payload: {
                ...proceedAction.payload,
                requestType: UPDATE_REQUEST_TYPE.EMAIL,
                requestValue: inputValue
            },
        });
        setLoading(false);
    };
    const footerChild = useMemo(() => {
        return (React.createElement(BottomBar, { typeDLS: BottomBarDLSType.TYPE_A, btnLabel: 'Submit', btnTypeDLS: ButtonTypeDLS.PRIMARY, btnSizeDLS: ButtonSizeDLS.MEDIUM, onPress: handleSubmit, btnLoading: loading, isDisabled: validNumber ? false : true }));
    }, [inputValue, validNumber, loading]);
    const handleCloseModal = async () => {
        await triggerAction(closeModal);
    };
    const renderContent = () => {
        return (React.createElement(View, { style: { marginTop: 24, paddingHorizontal: 16 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: 'Enter new email ID', color: ColorTokens.Grey_Night }),
            React.createElement(View, { style: { marginTop: 32 } },
                React.createElement(TextInput, { showErrorAnimation: true, extraSpace: 15, isLowerCase: true, value: inputValue, isFocus: true, clearEnabled: false, regex: RegexConfig.EMAIL, isDarkMode: isDarkMode ? true : false, type: InputTypeToken.EMAIL, state: currentState, title: "Email ID", keyboardType: KeyboardTypeToken.email, placeholder: "Enter your email ID", onChangeText: (text) => {
                        setInputValue(text);
                        if (regex.test(text)) {
                            setValidNumber(true);
                            setCurrentState(InputStateToken.DEFAULT);
                        }
                        else {
                            setCurrentState(InputStateToken.ERROR);
                            setValidNumber(false);
                        }
                    }, triggerAction: triggerAction })),
            React.createElement(View, { style: { marginTop: 4 } },
                React.createElement(Typography, { label: 'OTP will be sent to this new email for confirmation', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }))));
    };
    const errorModalContentPresenter = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SystemError })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "Email ID already exists" })),
            React.createElement(View, { style: { marginTop: 8, backgroundColor: '#F1F3F5', borderRadius: 8, padding: 12 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center, label: errorMessage })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Got it', onPress: handleCloseModal, isDisabled: false }))));
    };
    const renderOtpErrorModalBody = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_REDBG_DLS, size: IconSizeTokens.XXXXXXL, color: ColorTokens.System_Warning })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "OTP Attempts Exceeded" })),
            React.createElement(View, { style: { padding: 16, backgroundColor: '#F1F3F5', borderRadius: 8, marginTop: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: errorMessage, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: "Ok, got it!", onPress: handleCloseModal, isDisabled: false }))));
    };
    const defaultErrorModalContent = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SystemError })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "Verification failed!" })),
            React.createElement(View, { style: { marginTop: 2 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center, label: errorMessage })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Retry', onPress: handleCloseModal, isDisabled: false }))));
    };
    const modalContentPresenter = () => {
        if (showErrorModal) {
            return errorModalContentPresenter();
        }
        else if (defaultErrorModal) {
            return defaultErrorModalContent();
        }
        else if (showOtpErrorModal) {
            return renderOtpErrorModalBody();
        }
    };
    const BottomModal = () => {
        return (showErrorModal || defaultErrorModal || showOtpErrorModal) ? (React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                zIndex: 99
            } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: currentModalHeight, width: '100%', closeFunction: handleCloseModal, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: false }, modalContentPresenter()))) : React.createElement(React.Fragment, null);
    };
    return (React.createElement(BoilerPlate, { height: height, headerChild: headerChild, heightHeader: Platform.OS === 'ios' ? 93 : 57, bottomChildren: React.createElement(React.Fragment, null,
            footerChild,
            showNeedHelp && React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails }),
            BottomModal(),
            showOtpModal &&
                React.createElement(OtpModalScreenDc, { showOtpModal: showOtpModal, setShowOtpModal: setShowOtpModal, caption: caption, state: state, title: 'Confirm new email ID', subTitle: 'OTP sent to', value: inputValue, iconUrl: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/icon_holder.png', action: async (text) => {
                        await triggerAction({
                            ...action,
                            payload: {
                                ...action.payload,
                                otp: text,
                            },
                        });
                    }, otpAction: async () => {
                        await triggerAction({
                            ...otpAction,
                            payload: {
                                ...otpAction.payload,
                                requestValue: inputValue
                            },
                        });
                    }, handleCloseOtpModal: async () => {
                        await triggerAction(handleCloseOtpModalAction);
                    }, triggerAction: triggerAction })), backgroundColor: ColorTokens.White },
        React.createElement(React.Fragment, null, renderContent())));
};
const styles = StyleSheet.create({});
export default UpdateEmailScreen;
